<template>
    <div class="c-box p-5">
        <div class="c-box__header mb-5">
            <div class="c-box__title text-center text-uppercase">
                Login to your account
            </div>
        </div>
        <div class="c-form">
            <form @submit.prevent="sign_in">
                <div class="row form-group c-form__group">
                    <label for="cId" class="col-12 c-form__label">Panel ID</label>

                    <div class="col-12">
                        <b-form-input name="cId" id="cId" v-model.trim="c_id"></b-form-input>
                    </div>
                </div>
                <div class="row form-group c-form__group">
                    <label for="username" class="col-12 c-form__label">Email</label>

                    <div class="col-12">
                        <b-form-input name="username" id="username" v-model.trim="username"></b-form-input>
                    </div>
                </div>
                <div class="row form-group c-form__group">
                    <label for="password" class="col-12 c-form__label">Password</label>

                    <div class="col-12">
                        <b-form-input name="password" type="password" id="password" v-model="password"></b-form-input>
                    </div>
                </div>
                <div class="row form-group c-form__group">
                    <label for="two_fa_code" class="col-12 c-form__label">2FA Code</label>

                    <div class="col-12">
                        <b-form-input id="two_fa_code" v-model="two_fa_code"></b-form-input>
                    </div>
                    <div class="col-12">
                        <p class="form-text text-muted">Only if using 2FA.</p>
                    </div>
                </div>
                <button v-if="login_in_progress === false" class="c-btn c-btn--success">
                    Sign in
                </button>
                <button v-else disabled class="c-btn c-btn-default js--btn-loading-modal">
                    Loading...
                </button>
                <router-link :to="{ name: 'forgot_password.main', params: { company_id: c_id } }" class="c-btn c-btn-default">
                    Forgot password?
                </router-link>
            </form>
            <login-password-main-ccs-modal></login-password-main-ccs-modal>
        </div>
    </div>
</template>

<script>
import CcsModal from "@/components/CcsModal.vue";

export default {
    metaInfo: {
        title: "Login"
    },

    components: {
        LoginPasswordMainCcsModal: CcsModal
    },

    mounted() {},

    props: {
        company_id: {
            type: Number,
            default: undefined
        }
    },

    data: function() {
        return {
            login_in_progress: false,

            c_id: this.company_id,
            username: "",
            password: "",
            two_fa_code: ""
        };
    },

    watch: {},

    computed: {},

    methods: {
        sign_in: function() {
            if (this.c_id === undefined || this.c_id === "" || Number.isInteger(parseInt(this.c_id)) === false) {
                this.$modal.show("login-password-main-ccs-modal-dialog", {
                    type: "error",
                    title: "Error while attempting to login",
                    text: "Please fill in the Panel Id field",
                    buttons: [
                        {
                            title: "Close",
                            default: false // Will be triggered by default if 'Enter' pressed.
                        }
                    ]
                });

                return;
            }

            let payload = {
                company_id: this.c_id,
                username: this.username,
                password: this.password,
                two_fa_code: this.two_fa_code
            };

            this.login_in_progress = true;
            this.$store.dispatch("user/LoginUser", payload).then(
                (success_data) => {
                    this.login_in_progress = false;
                    this.password = "";
                    this.two_fa_code = "";
                    if (
                        this.$store.state.user.account_data.force_2fa === 1 &&
                        this.$store.state.user.account_data["2fa_enabled"] === 0
                    ) {
                        this.$router.push({ name: "login.force_2fa" });
                    } else {
                        window.location.href = this.$router.resolve({ name: "domains.index" }).href;
                    }
                },
                (error_data) => {
                    this.login_in_progress = false;
                    if(parseInt(error_data.user_login_status) === 13107) // ACCOUNT NOT ACTIVATED
                    {
                      this.$modal.show("login-password-main-ccs-modal-dialog", {
                        type: "warning",
                        title: "Panel account is not activated",
                        text: error_data.user_login_info,
                        buttons: [
                          {
                            title: "Resend activation e-mail",
                            class: "c-btn c-btn--warning c-btn--primary",
                            handler: () => {
                              this.resend_invite_email();
                            },
                          }
                        ]
                      });
                    }
                    else // LOGIN FAILED
                    {
                      this.$modal.show("login-password-main-ccs-modal-dialog", {
                        type: "error",
                        title: "Login failed",
                        text: error_data.user_login_info,
                        buttons: [
                          {
                            title: "Close",
                            default: true
                          }
                        ]
                      });
                    }
                    return;
                }
            );
        },

        resend_invite_email: function() {
          if (this.c_id === undefined || this.c_id === "" || Number.isInteger(parseInt(this.c_id)) === false) {
            this.$modal.hide("login-password-main-ccs-modal-dialog");
            this.$modal.show("login-password-main-ccs-modal-dialog", {
              type: "error",
              title: "Error while attempting to send activation e-mail",
              text: "Please fill in the Panel ID field",
              buttons: [
                {
                  title: "Close",
                  default: false // Will be triggered by default if 'Enter' pressed.
                }
              ]
            });

            return;
          }

          let payload = {
            company_id: this.c_id,
            username: this.username,
          };

          this.$store.dispatch("user/ResendActivateEmail", payload).then(
              (success_data) => {
                this.$modal.hide("login-password-main-ccs-modal-dialog");
                this.$modal.show("login-password-main-ccs-modal-dialog", {
                  type: "success",
                  title: "Activation email successfully sent",
                  text: "Please check your email for the link to activate your account",
                  buttons: [
                    {
                      title: "Close",
                      default: true // Will be triggered by default if 'Enter' pressed.
                    }
                  ]
                });
              },
              (error_data) => {
                this.$modal.hide("login-password-main-ccs-modal-dialog");
                  this.$modal.show("login-password-main-ccs-modal-dialog", {
                  type: "warning",
                  title: "Could not send activation email",
                  text: error_data,
                  buttons: [
                    {
                      title: "Close",
                      default: true // Will be triggered by default if 'Enter' pressed.
                    }
                  ]
                });
                return;
              }
          );
        }
    }
};
</script>
